<ng-container *ngIf="routerLink; else normalButton">
  <desy-button
    [disabled]="disabled"
    [routerLink]="!disabled ? routerLink : null"
    (clickEvent)="onClick()"
    [classes]="!disabled ? 'bg-primary-base text-white hover:bg-primary ' : ''"
    [type]="type">
    <div
      class="flex justify-center items-center"
      [ngClass]="classPositions">
      <i
        class="font-semibold"
        [ngClass]="icon"
        *ngIf="icon"
        alt="icon"></i>
      <span>{{ label }}</span>
    </div>
  </desy-button>
</ng-container>

<ng-template #normalButton>
  <desy-button
    [disabled]="disabled"
    (clickEvent)="onClick()"
    [classes]="classes"
    [type]="type">
    <div
      class="flex justify-center items-center"
      [ngClass]="classPositions">
      <i
        class="font-semibold"
        [ngClass]="icon"
        *ngIf="icon"
        alt="icon"></i>
      <span>{{ label }}</span>
    </div>
  </desy-button>
</ng-template>
